<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title eng="USER GUIDE" :jpn="t('ご利用ガイド')" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('①会員登録')"
        >
          <div class="text-container">
            <span class="text">ご利用頂くためには会員登録(無料)が必須となります。</span>
            <span class="text">※会員登録の際にはメールアドレスが必要になりますが、Gmailもしくはyahooのメールアドレスを推奨しております。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('②ポイント購入')"
          id="howtopay"
        >
          <div class="text-container">
            <span class="text">・商品はポイントで購入が可能です。</span>
            <span class="text">・そのため、まずはポイントをご購入ください。</span>
            <span class="text">・1P=1円となり、300P〜50,000Pの中でご選択頂けます。</span>
            <span class="text">・本サイト内では、クレジットカード決済・コンビニ決済・キャリア決済・メルペイの決済が可能です。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          :title="t('③商品購入')"
          id="howtosend"
        >
          <div class="text-container">
            <span class="text">
              ご希望の商品をタップして、ご希望の購入数をご選択ください。<br>
              その上で画面を進んで頂くと、演出動画が流れます。<br>
              演出動画で表示される色合いによって排出されるカードが変わります。<br>
              ※複数お買い求めいただいた際はその数分演出動画が流れます。(演出動画はALL SKIPも可能です)<br>
              <br>
              その後は、カード1枚1枚に対して「ポイント還元」もしくは「発送依頼」のいずれかをご選択頂きます。<br>
              一度決定してしまうと後からの変更は不可能となりますのでご慎重にお願いいたします。<br>
              また、24時間以内にご選択頂かなかった場合は自動でポイントに変わります。<br>
              予めご容赦くださいませ。<br>
              <br>
              ・「ポイント還元」をご選択の場合<br>
              →排出されたカードの代わりに次回以降本サイトでご利用頂けるポイントを得ることができます。<br>
              <br>
              ・「発送依頼」をご選択の場合<br>
              →排出されたカードを発送いたします。<br>
            </span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'UserGuide',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1600px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  color: #4a3f3a;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 360px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          // color: $white;
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
  .center {
    text-align: left;
  }
}
a {
  color: $black!important;
}
</style>
